<mat-dialog-actions>
  <button class="btn close" type="button" mat-dialog-close></button>
</mat-dialog-actions>
  <div class="list-container">
    <div class="scrollbar-custom">
    <mat-expansion-panel [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <h2>{{ 'Document Viewer' | translate }}</h2>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-pdf-viewer [src]="data" *ngIf="data; else noFile"></app-pdf-viewer>
      <ng-template #noFile>{{ 'File not found, please contact your administrator.' | translate }}</ng-template>
      <mat-action-row *ngIf="data">
        <a [href]="data" download target="_blank" type="application/octet-stream">
          <button mat-button class="btn btn-primary" type="button"><mat-icon>file_download</mat-icon>{{ 'Download' | translate }}</button>
        </a>
      </mat-action-row>
    </mat-expansion-panel>
  </div>
</div>
